// SPDX-FileCopyrightText: 2023 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '@tls/auth';
import { Background, Details, Title } from './Background';
import { AppRoutes } from 'utilities/router/AppRoutes';
import styled from 'styled-components';
import IconError from 'components/treactui-template/icons/IconError';
import IconHome from 'components/treactui-template/icons/IconHome';
import { Button, Colors } from '@tls/treact-ui';

export default function ErrorBound() {
  const { t } = useTranslation();
  const { appBaseUrl } = useAuthContext();
  const goHome = useCallback(() => (window.location.href = `${appBaseUrl}${AppRoutes.Projects}`), [appBaseUrl]);

  return (
    <Background $appBaseUrl={appBaseUrl ?? ''}>
      <Icon className='icon'>
        <IconError width={'15rem'} />
      </Icon>
      <Details className='text'>
        <Title>{t('error.title')}</Title>
        <div className='font-size_m details'>{t('error.details')}</div>

        <Button
          icon={<IconHome />}
          className='margin-top'
          label={t('error.home')}
          onClick={goHome}
          variant='secondary'
          data-testid='app-error-home-button'
        />
      </Details>
    </Background>
  );
}

const Icon = styled.div`
  font-size: 8rem;
  font-weight: 700;
  color: ${Colors.trblue35.hex};
  margin-right: 10rem;
`;
